import { useCallback, useState } from 'react';

// Selección múltiple (11-oct-2026): modo "Seleccionar" + los ids tildados.
export function useSeleccion() {
    const [activo, setActivo] = useState(false);
    const [sel, setSel] = useState(() => new Set());
    const alternar = useCallback(id => setSel(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; }), []);
    const todos = useCallback(ids => setSel(s => (ids.every(i => s.has(i)) ? new Set() : new Set(ids))), []);
    const salir = useCallback(() => { setActivo(false); setSel(new Set()); }, []);
    const entrar = useCallback((id = null) => { setActivo(true); setSel(id != null ? new Set([id]) : new Set()); }, []);
    return { activo, entrar, salir, sel, alternar, todos, cantidad: sel.size, tiene: id => sel.has(id) };
}

// Corre una acción sobre varios ids uno por uno y dice cuántos salieron bien.
// Devuelve los ids que fallaron (con el primer mensaje de error).
export async function enLote(ids, accion) {
    const fallaron = [];
    let mensaje = null;
    for (const id of ids) {
        try { await accion(id); } catch (e) { fallaron.push(id); mensaje = mensaje || e?.response?.data?.mensaje || null; }
    }
    return { ok: ids.length - fallaron.length, fallaron, mensaje };
}
